module.exports = __webpack_public_path__ + "media/images/common/ordered_limited_product-6d4324c2826d56b70abbf98f3c920212.png";